export const Messages = {
  lastCheck: 'Last check: ',
  checkAriaLabel: 'Check for updates',
};
